import { HierarchyContextProps, IHierarchyActionSetAccessRights } from "../interface";

/**
 * Updates the loaded access rights for the current hierarchy.
 *
 * @param state - The current hierarchy context state.
 * @param action - The set-access-rights action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_setAccessRights = (
  state: HierarchyContextProps,
  action: IHierarchyActionSetAccessRights,
): HierarchyContextProps => ({
  ...state,
  accessRights: action.accessRights,
  doGetAccessRights: false,
});
